import React from 'react';
import {
  Box,
  Button,
  Breadcrumbs,
  Link,
  Typography,
} from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { HomeOutlined } from '@material-ui/icons';

export default function EventBreadCrumb({ initPath, event }) {
  const history = useHistory();
  if (!event) return null;
  const year = moment(event.start_date).format('YYYY');
  const yearCreatedAt = moment(event.created_at).format('YYYY');
  return (
    <Box mb={3}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Breadcrumbs aria-label="breadcrumb" style={{ fontSize: 13 }}>
          {/* Dashboard */}
          <Link
            color="inherit"
            component={RouterLink}
            to={`${initPath}reportwater/events`}
            underline="hover"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <HomeOutlined fontSize="small" style={{ marginRight: 4 }} />
            <Typography variant="subtitle2" color="textSecondary">
              Dashboard ระบบเหตุการณ์สถานการณ์น้ำ
            </Typography>
          </Link>

          {/* Year */}
          <Link
            component={RouterLink}
            to={`${initPath}reportwater/events?year=${year}`}
            color="inherit"
            underline="hover"
          >
            <Typography variant="subtitle2" color="textSecondary">
              ปี
              {' '}
              {yearCreatedAt}
            </Typography>
          </Link>

          {/* Event name */}
          <Typography variant="subtitle2" color="textPrimary">
            {event.event_name || '-'}
          </Typography>
        </Breadcrumbs>

        <Button
          size="small"
          variant="outlined"
          color="primary"
          startIcon={<ArrowBackIcon />}
          onClick={() => history.goBack()}
        >
          กลับ
        </Button>
      </Box>
    </Box>
  );
}

/* ✅ PropTypes */
EventBreadCrumb.propTypes = {
  initPath: PropTypes.string.isRequired,
  event: PropTypes.shape({
    start_date: PropTypes.string,
    created_at: PropTypes.string,
    event_name: PropTypes.string,
  }),
};

EventBreadCrumb.defaultProps = {
  event: {},
};
